<div class="row" [ngClass]="field.customClass">
  <div [ngClass]="itemClass">
    <app-date
      [field]="startField"
      [control]="startControl"
      [disabled]="disabled"
      [max]="endControl.value"
    ></app-date>
    @if (!this.control.errors) {
      <app-field-error
        class="d-block"
        [control]="startControl"
        [field]="startControl"
      ></app-field-error>
    }
  </div>
  <div [ngClass]="itemClass">
    <app-date
      [field]="endField"
      [control]="endControl"
      [disabled]="disabled"
      [min]="startControl.value"
    ></app-date>
    @if (!this.control.errors) {
      <app-field-error
        class="d-block"
        [control]="endControl"
        [field]="endField"
      ></app-field-error>
    }
  </div>
</div>
